import { collectVisibleLivePreviewMedia } from '@/helpers/capturePlayerLivePreview'

/**
 * Largest visible &lt;video&gt;/&lt;img&gt; on-screen bounding box under the live-preview root.
 * Cold-path only (frame transition / heartbeat) — not per RAF tick.
 */
export function sampleVisibleMediaRectForAspectTelemetry(): {
  widthPx: number
  heightPx: number
} | null {
  if (typeof document === 'undefined') {
    return null
  }
  const root = document.querySelector('[data-player-live-preview-root]')
  if (root == null) {
    return null
  }
  const candidates = collectVisibleLivePreviewMedia(root)
  const top = candidates[0]
  if (top == null) {
    return null
  }
  // Use painted rect (getBoundingClientRect already applied in collect via area, but we need dims).
  // Re-query the source element's rect — candidates only store intrinsic media pixels + area.
  if (top.source instanceof HTMLVideoElement || top.source instanceof HTMLImageElement) {
    const rect = top.source.getBoundingClientRect()
    if (rect.width >= 32 && rect.height >= 32) {
      return { widthPx: rect.width, heightPx: rect.height }
    }
  }
  return null
}
